import { computed } from 'vue'
import type { Component } from 'vue'

import { useDevice } from '#imports'

interface PageByDevice {
  component?: Component
  layout: ComputedRef<'desktop' | 'mobile'>
}

export function usePageByDevice(componentDesktop?: Component, componentMobile?: Component): PageByDevice {
  const { isMobile } = useDevice()
  const component = computed(() => {
    return isMobile ? componentMobile : componentDesktop
  })
  const layout = computed(() => {
    return isMobile ? 'mobile' : 'desktop'
  })
  return {
    component: component.value,
    layout
  }
}
